import { usePermissionsContext } from "../PermissionsContext";

export const usePermission = () => {

  const { authorities } = usePermissionsContext();

  const can = (permission) => {
    return authorities.includes(permission);
  };

  return { can };

};